import {
  object, string, boolean, array
} from 'yup';
import 'yup-phone';

export const accessSchema = object().shape({
  fullName: string().required('Full name is required'),
  email: string()
    .email('Invalid email address')
    .required('Email is required'),
  occupation: string().required('Occupation is required'),
  company: string().required('Company is required'),
  affiliation: string().required('Affiliation is required'),
  zipCode: string().required('Zip code is required'),
  country: string().required('Country is required'),
  age: boolean(),
});

export const emailSchema = object().shape({
  email: string()
    .email('Please enter a valid email address')
    .required('Please enter a valid email address'),
  name: string()
    .matches(/^[A-Za-zÀ-ÿ]+[A-Za-zÀ-ÿ\s]*$/, 'Please enter a valid name')
    .required('Please enter your name'),
  privacy: boolean().oneOf(
    [true],
    'Please accept the Privacy Policy to continue'
  ),
});

export const surveySchema = object().shape({
  email: string()
    .email('Please enter a valid email address')
    .required('Please enter a valid email address'),
  name: string()
    .matches(/^[^\s].+[^\s]*$/g, 'Please enter a valid name')
    .required('Please enter your name'),
  age: string()
    .required(
      'Please select an option'
    ),
  dateDose1: string()
    .required('Please enter a date'),
  noDateDose2: string()
    .required('Please enter a date or select "I don\'t know" option'),
  smartphone: string()
    .required(
      'Please select an option'
    ),
});

export const shippingSchema = object().shape({
  phone: string()
    .phone('US', true, 'Please enter a valid phone number')
    .required('Please enter your phone'),
  address: string()
    .required('Please enter your address'),
  city: string()
    .required('Please enter a city name'),
  state: string()
    .required('Please select a state'),
  zip_code: string()
    .matches(/^[0-9]{5}$/, 'Please enter a valid ZIP code')
    .test('min', 'Please enter a valid ZIP code', val => val ? parseInt(val, 10) > 0 : true)
    .required('Please enter a ZIP code'),
  band_size: string()
    .required('Please select an option'),
});

export const phoneSchema = object().shape({
  phone: string()
    .phone('US', false, 'Please enter a valid phone number')
    .required(),
  name: string()
    .matches(/^[A-Za-zÀ-ÿ]+[A-Za-zÀ-ÿ\s]*$/, 'Please enter a valid name')
    .required('Please enter your name'),
  privacy: boolean().oneOf(
    [true],
    'Please accept the Privacy Policy to continue'
  ),
});

export const phoneGcSchema = object().shape({
  phone: string()
    .phone('US', false, 'Please enter a valid phone number')
    .required(),
  name: string()
    .matches(/^[A-Za-zÀ-ÿ]+[A-Za-zÀ-ÿ\s]*$/, 'Please enter a valid name')
    .required('Please enter your name'),
  privacy: boolean().oneOf(
    [true],
    'Please accept the Privacy Policy to continue'
  ),
});

export const dsrSchema = object().shape({
  fullName: string().trim().required('Please enter your full name'),
  email: string()
    .email('Please enter a valid email address')
    .required('Please enter your email address'),
  phone: string()
    .phone('US', false, 'Please enter a valid phone number')
    .required('Please enter your phone number'),
  phoneConsent: boolean().oneOf([true], 'Please check the box above to continue.'),
  state: string().required('Please select your state of residence'),
  requesterType: string().required('Please select an option'),
  requestTypes: array()
    .of(string())
    .min(1, 'Please select at least one type of request'),
  isAuthorizedAgent: boolean(),
  consumerName: string().when('isAuthorizedAgent', {
    is: true,
    then: string()
      .trim()
      .required('Please enter the name of the person you are submitting for'),
    otherwise: string(),
  }),
  details: string(),
});

export const contactSchema = object().shape({
  name: string().trim().required('Please enter your name'),
  email: string()
    .email('Please enter a valid email address')
    .required('Please enter your email address'),
  message: string().trim().required('Please enter a message'),
});
